import {
  SHOW_CONFIRMATION,
  HIDE_CONFIRMATION,
} from '@state/actions/confirmationActions'

/**
 * Initial state
 */
const initialConfirmationState = {
  title: '',
  text: '',
  additionalText: '',
  confirmText: '',
  cancelText: '',
  show: false,
}

/**
 * Reducer
 */
const confirmationReducer = (state, action) => {
  switch (action.type) {
    case SHOW_CONFIRMATION:
      return {
        ...state,
        show: true,
        title: action.payload.title,
        text: action.payload.text,
        additionalText: action.payload.additionalText,
        confirmText: action.payload.confirmText,
        cancelText: action.payload.cancelText,
      }

    case HIDE_CONFIRMATION:
      return {
        ...state,
        show: false,
        title: '',
        text: '',
        additionalText: '',
        confirmText: '',
        cancelText: '',
      }

    default:
      return state
  }
}

export { confirmationReducer, initialConfirmationState }
